import {Injectable} from '@angular/core';
import {map, Observable, throwError} from 'rxjs';
import {FindData} from '@api/common';
import {ResourceType, ScheduleDetail, ScheduleEndpoint, ScheduleSession} from '@api/planner';

@Injectable({providedIn: 'root'})
export class ScheduleDetailData extends FindData<ScheduleDetail> {

  private organisationId: string | null = null;

  sessions$: Observable<ScheduleSession[]> = this.item$.pipe(
    map(detail => detail?.sessions ?? [])
  );

  resourceTypes$: Observable<ResourceType[]> = this.item$.pipe(
    map(detail => detail?.resourceTypes ?? [])
  );

  constructor(private endpoint: ScheduleEndpoint) {
    super();
  }

  setOrganisationId(organisationId: string): void {
    this.organisationId = organisationId;
  }

  getOrganisationId(): string | null {
    return this.organisationId;
  }

  protected findCall(id: number): Observable<ScheduleDetail> {
    if (!this.organisationId) {
      return throwError(() => new Error('Organisation ID not set'));
    }
    return this.endpoint.getById(this.organisationId, id);
  }
}
